import { useLocation } from "react-router-dom";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { API } from "../../API";
import { notify } from "react-notify-toast";
import Auth from "../../Auth/Auth";

const useGrantAccess = (props) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const { search, pathname } = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(search);
  const handleUpdateGrantAccess = async () => {
    try {
      const day = searchParams.get("day");
      const params = {
        status: searchParams.get("accept") === "true" ? "accepted" : "rejected",
        expired_at: moment()
          ?.add(day || 0, "days")
          ?.format("YYYY-MM-DD hh:mm:ss"),
      };
      await API.updateRequestToViewCalendarV2(
        params,
        searchParams.get("request_view_id")
      );
      setIsOpenModal(true);
      setLoading(false);
      // window.localStorage.removeItem("path");
      history.push("/myCalendar?isSendedCalendar=true");
    } catch (error) {
      notify.show(error?.response?.data.message);
      localStorage.setItem("userType", "teacherLogin")
      localStorage.setItem("request_view_id", searchParams.get("request_view_id"))
      Auth.logout()
      history.push(`/Login?vtid=${searchParams.get("teacher_id")}`);
    }
  };

  const handleSubmitUpdateRequestCalendar = () => {
    history.push("/dashboard");
  };

  useEffect(() => {
    window.localStorage.setItem(
      "request_view_id",
      searchParams.get("request_view_id")
    );
    handleUpdateGrantAccess();
  }, []);
  return {
    ...props,
    isOpenModal,
    loading,
    handleSubmitUpdateRequestCalendar,
  };
};

export default useGrantAccess;
